// Modern Hero Slider with Auto-play
class HeroSlider {
  constructor() {
    this.slider = document.querySelector('.hero-slides');
    this.slides = document.querySelectorAll('.hero-slide');
    this.currentSlide = 0;
    this.slideCount = this.slides.length;
    this.autoplayInterval = null;
    
    if (this.slideCount > 1) {
      this.init();
    }
  }

  init() {
    // Create navigation dots
    this.createDots();
    
    // Create arrow buttons
    this.createArrows();
    
    // Start autoplay
    this.startAutoplay();
    
    // Pause on hover (desktop)
    if (this.slider) {
      this.slider.addEventListener('mouseenter', () => this.stopAutoplay());
      this.slider.addEventListener('mouseleave', () => this.startAutoplay());
    }
    
    // Touch swipe support
    this.addTouchSupport();
  }

  createDots() {
    const dotsContainer = document.querySelector('.slider-dots-wrapper');
    if (!dotsContainer) return;
    
    for (let i = 0; i < this.slideCount; i++) {
      const dot = document.createElement('button');
      dot.className = `slider-dot ${i === 0 ? 'active' : ''}`;
      dot.setAttribute('aria-label', `Go to slide ${i + 1}`);
      dot.addEventListener('click', () => this.goToSlide(i));
      dotsContainer.appendChild(dot);
    }
  }

  createArrows() {
    const prevArrow = document.querySelector('.slider-arrow--prev');
    const nextArrow = document.querySelector('.slider-arrow--next');
    
    if (prevArrow) {
      prevArrow.addEventListener('click', () => this.prevSlide());
    }
    
    if (nextArrow) {
      nextArrow.addEventListener('click', () => this.nextSlide());
    }
  }

  goToSlide(index) {
    this.currentSlide = index;
    this.updateSlider();
  }

  nextSlide() {
    this.currentSlide = (this.currentSlide + 1) % this.slideCount;
    this.updateSlider();
  }

  prevSlide() {
    this.currentSlide = (this.currentSlide - 1 + this.slideCount) % this.slideCount;
    this.updateSlider();
  }

  updateSlider() {
    // Move slides
    const offset = -this.currentSlide * 100;
    this.slider.style.transform = `translateX(${offset}%)`;
    
    // Update dots
    const dots = document.querySelectorAll('.slider-dot');
    dots.forEach((dot, index) => {
      dot.classList.toggle('active', index === this.currentSlide);
    });
  }

  startAutoplay() {
    this.autoplayInterval = setInterval(() => {
      this.nextSlide();
    }, 5000);
  }

  stopAutoplay() {
    if (this.autoplayInterval) {
      clearInterval(this.autoplayInterval);
    }
  }

  addTouchSupport() {
    let touchStartX = 0;
    let touchEndX = 0;
    
    this.slider.addEventListener('touchstart', (e) => {
      touchStartX = e.changedTouches[0].screenX;
    });
    
    this.slider.addEventListener('touchend', (e) => {
      touchEndX = e.changedTouches[0].screenX;
      this.handleSwipe();
    });
    
    const handleSwipe = () => {
      if (touchEndX < touchStartX - 50) {
        this.nextSlide();
      }
      if (touchEndX > touchStartX + 50) {
        this.prevSlide();
      }
    };
    
    this.handleSwipe = handleSwipe;
  }
}

// Initialize slider on page load
document.addEventListener('DOMContentLoaded', () => {
  new HeroSlider();
});

